import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';

@NgModule({
  declarations: [
  ],
  imports: [
    IonicModule
  ],
  exports: [

  ],
  providers: [
  ]
})
export class ChartComponentModule {}



// WEBPACK FOOTER //
// ./src/components/chart/chart.module.ts